import { createReducer, on } from '@ngrx/store'
import { appProgressbarClose, appProgressbarStart, appProgressbarUpdate } from '../../models/interfaces/app-progressbar-state.interface'
import * as LumpSumActions from './lump-sum.actions'
import { LumpSumState } from './lump-sum.state'

export const initialLumpSumState: LumpSumState = {
   summaryForWp: {},
   workpackageList: [],
   costPerWp: {},
   estimatedBreakdown: {},
   personMonths: {},
   depreciation: {}
}

export const lumpSumReducer = createReducer(
   initialLumpSumState,
   on(LumpSumActions.downloadLumpSum, (state) => ({ ...state, exportProgress: appProgressbarStart() })),
   on(LumpSumActions.downloadLumpSumSuccess, (state, { response }) => ({
      ...state,
      exportProgress: appProgressbarUpdate(state.exportProgress || appProgressbarStart(), response)
   })),
   on(LumpSumActions.downloadLumpSumFailure, (state) => ({ ...state, exportProgress: appProgressbarClose('error') })),
   on(LumpSumActions.closeExportProgress, (state) => ({ ...state, exportProgress: undefined })),

   // wp
   on(LumpSumActions.load_LS_Workpackages, (state) => {
      return {
         ...state,
         workpackageList: undefined,
         isLoadingWorkpackageList: true
      }
   }),
   on(LumpSumActions.load_LS_WorkpackagesSuccess, (state, action) => {
      return {
         ...state,
         workpackageList: action.response,
         isLoadingWorkpackageList: undefined
      }
   }),
   on(LumpSumActions.load_LS_WorkpackagesFailure, (state) => {
      return { ...state, isLoadingWorkpackageList: undefined }
   }),

   // summary for wp
   on(LumpSumActions.load_LS_SummaryForWpData, (state) => {
      return {
         ...state,
         summaryForWp: {
            ...state.summaryForWp,
            summaryForWpData: undefined,
            isLoadingSummaryForWpData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_SummaryForWpDataSuccess, (state, action) => {
      return {
         ...state,
         summaryForWp: {
            ...state.summaryForWp,
            summaryForWpData: action.response,
            isLoadingSummaryForWpData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_SummaryForWpDataFailure, (state) => {
      return { ...state, summaryForWp: { ...state.summaryForWp, isLoadingSummaryForWpData: undefined } }
   }),

   //   beneficiaries list
   on(LumpSumActions.load_LS_BeneficiariesList, (state) => {
      return {
         ...state,
         beneficiariesList: undefined,
         isLoadingBeneficiariesList: true
      }
   }),
   on(LumpSumActions.load_LS_BeneficiariesListSuccess, (state, action) => {
      return {
         ...state,
         beneficiariesList: action.response,
         isLoadingBeneficiariesList: undefined
      }
   }),

   on(LumpSumActions.load_LS_BeneficiariesListFailure, (state) => {
      return { ...state, isLoadingBeneficiariesList: undefined }
   }),

   // costs per wp
   on(LumpSumActions.load_LS_CostsPerWpBeneficiarySummaryTableData, (state) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            beneficiarySummaryTableData: undefined,
            isLoadingBeneficiarySummaryTableData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_CostsPerWpBeneficiarySummaryTableDataSuccess, (state, action) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            beneficiarySummaryTableData: action.response,
            isLoadingBeneficiarySummaryTableData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_CostsPerWpBeneficiarySummaryTableDataFailure, (state) => {
      return { ...state, costPerWp: { ...state.costPerWp, isLoadingBeneficiarySummaryTableData: undefined } }
   }),

   on(LumpSumActions.load_LS_CostsPerWpSingleWpTableData, (state) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            singleWpTableData: undefined,
            isLoadingSingleWpTableData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_CostsPerWpSingleWpTableDataSuccess, (state, action) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            singleWpTableData: action.response,
            isLoadingSingleWpTableData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_CostsPerWpSingleWpTableDataFailure, (state) => {
      return { ...state, costPerWp: { ...state.costPerWp, isLoadingSingleWpTableData: undefined } }
   }),

   on(LumpSumActions.update_LS_CostsPerWpSingleWpTableData, (state) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            isLoadingUpdateSingleWpTableData: true
         }
      }
   }),
   on(LumpSumActions.update_LS_CostsPerWpSingleWpTableDataSuccess, LumpSumActions.update_LS_CostsPerWpSingleWpTableDataFailure, (state) => {
      return {
         ...state,
         costPerWp: {
            ...state.costPerWp,
            isLoadingUpdateSingleWpTableData: undefined
         }
      }
   }),

   // estimated breakdown
   on(LumpSumActions.load_LS_EstimatedBreakdownData, (state) => {
      return {
         ...state,
         estimatedBreakdown: {
            ...state.estimatedBreakdown,
            estimatedBreakdownData: undefined,
            isLoadingEstimatedBreakdownData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_EstimatedBreakdownDataSuccess, (state, action) => {
      return {
         ...state,
         estimatedBreakdown: {
            ...state.estimatedBreakdown,
            estimatedBreakdownData: action.response,
            isLoadingEstimatedBreakdownData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_EstimatedBreakdownDataFailure, (state) => {
      return { ...state, estimatedBreakdown: { ...state.estimatedBreakdown, isLoadingEstimatedBreakdownData: undefined } }
   }),

   // person months
   on(LumpSumActions.load_LS_PersonMonthsData, (state) => {
      return {
         ...state,
         personMonths: {
            ...state.personMonths,
            personMonthsData: undefined,
            isLoadingPersonMonthsData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_PersonMonthsDataSuccess, (state, action) => {
      return {
         ...state,
         personMonths: {
            ...state.personMonths,
            personMonthsData: action.response,
            isLoadingPersonMonthsData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_PersonMonthsDataFailure, (state) => {
      return { ...state, personMonths: { ...state.personMonths, isLoadingPersonMonthsData: undefined } }
   }),

   // depreciation
   on(LumpSumActions.load_LS_DepreciationData, (state) => {
      return {
         ...state,
         depreciation: {
            ...state.depreciation,
            depreciationData: undefined,
            isLoadingDepreciationData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_DepreciationDataSuccess, (state, action) => {
      return {
         ...state,
         depreciation: {
            ...state.depreciation,
            depreciationData: action.response,
            isLoadingDepreciationData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_DepreciationDataFailure, (state) => {
      return { ...state, depreciation: { ...state.depreciation, isLoadingDepreciationData: undefined } }
   }),

   on(LumpSumActions.update_LS_DepreciationData, (state) => {
      return {
         ...state,
         depreciation: {
            ...state.depreciation,
            isLoadingUpdateDepreciationData: true
         }
      }
   }),
   on(LumpSumActions.update_LS_DepreciationDataSuccess, LumpSumActions.update_LS_DepreciationDataFailure, (state) => {
      return {
         ...state,
         depreciation: {
            ...state.depreciation,
            isLoadingUpdateDepreciationData: undefined
         }
      }
   }),

   // general

   on(LumpSumActions.cleanLumpSumData, () => {
      return { ...initialLumpSumState }
   }),

   // resource types
   on(LumpSumActions.load_LS_ResourceTypes, (state) => {
      return {
         ...state,
         resourceTypes: undefined
      }
   }),
   on(LumpSumActions.load_LS_ResourceTypesSuccess, (state, action) => {
      return {
         ...state,
         resourceTypes: action.response
      }
   }),

   // any comments
   on(LumpSumActions.load_LS_AnyCommentsData, (state) => {
      return {
         ...state,
         anyComments: {
            ...state.anyComments,
            anyCommentsData: undefined,
            isLoadingAnyCommentsData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_AnyCommentsDataSuccess, (state, action) => {
      return {
         ...state,
         anyComments: {
            ...state.anyComments,
            anyCommentsData: action.response,
            isLoadingAnyCommentsData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_AnyCommentsDataFailure, (state) => {
      return { ...state, anyComments: { ...state.anyComments, isLoadingAnyCommentsData: undefined } }
   }),

   on(LumpSumActions.update_LS_AnyCommentsData, (state) => {
      return {
         ...state,
         anyComments: {
            ...state.anyComments,
            isLoadingUpdateAnyCommentsData: true
         }
      }
   }),
   on(LumpSumActions.update_LS_AnyCommentsDataSuccess, LumpSumActions.update_LS_AnyCommentsDataFailure, (state) => {
      return {
         ...state,
         anyComments: {
            ...state.anyComments,
            isLoadingUpdateAnyCommentsData: undefined
         }
      }
   }),

   // change log
   on(LumpSumActions.load_LS_ChangeHistoryData, (state) => {
      return {
         ...state,
         changeHistory: {
            ...state.changeHistory,
            changeHistoryData: undefined,
            isLoadingChangeHistoryData: true
         }
      }
   }),
   on(LumpSumActions.load_LS_ChangeHistoryDataSuccess, (state, action) => {
      return {
         ...state,
         changeHistory: {
            ...state.changeHistory,
            changeHistoryData: action.response,
            isLoadingChangeHistoryData: undefined
         }
      }
   }),
   on(LumpSumActions.load_LS_ChangeHistoryDataFailure, (state) => {
      return { ...state, changeHistory: { ...state.changeHistory, isLoadingChangeHistoryData: undefined } }
   }),

   on(LumpSumActions.update_LS_ChangeHistoryData, (state) => {
      return {
         ...state,
         changeHistory: {
            ...state.changeHistory,
            isLoadingUpdateHistoryLogData: true
         }
      }
   }),
   on(LumpSumActions.update_LS_ChangeHistoryDataSuccess, LumpSumActions.update_LS_ChangeHistoryDataFailure, (state) => {
      return {
         ...state,
         changeHistory: {
            ...state.changeHistory,
            isLoadingUpdateHistoryLogData: undefined
         }
      }
   })
)
